import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { FormInput, FormSelector } from "../FormElements/index";
import { Button } from "../Elements";
import AmountRange from "../AmountRange";
import FormObserver from "../FormElements/FormObserver";
import FormFiltersShortList from "../FormElements/FormFiltersShortList";
import { currencyTypes } from "../../../constants/options/currencyTypes";
import { customerSelectFrom, postMessageTypes } from "../../../constants/postMessageFileds";
import FormMultiSelect from "../FormElements/FormMultiSelect";
import { TbDots } from "react-icons/tb";
import { clearSheetPaymentCustomer, onSelectCurrencyTypes } from "../../../store/slices/sheetPaymentFiltersSlice"
import { postWebViewMessage, selectDepartment, selectDivision, selectGroupCodes } from "../../../common/helpers/messageHelper";
import appHelpers from "../../../common/helpers/appHelpers";
import { updateIsResetForm } from "../../../store/slices/formHelperSlice";
import { amountTypeVisible } from "../../../common/helpers/versionControls/version_1006";
import { toast } from "react-toastify";
import { isLogoAppProject } from "../../../common/helpers/globalHelpers";
import { buttonTexts } from "../../../constants/texts/buttonTexts";



const amountTypes = [
  {
    value: 1,
    label: "Toplam Borç Bakiyesi"
  },
  {
    value: 2,
    label: "Vadesi Geçmiş Borç Bakiyesi"
  }
]

export default function WithoutSheetDetailForm({ isOpen, setFiltersIsOpen }) {

  var currencyType = appHelpers.getPlatform() == "NETSIS" ? -1 : 0;
  const initialValues = {
    customerCode: "",
    currencyType: currencyType,
    selectedAmountType: 1,
    amountRange: {
      start: "0.00",
      end: "0.00",
    },
    code1: [],
    code2: [],
    code3: [],
    code4: [],
    code5: [],
    division: [],
    department: [],
    netsisGroupCode: []
  };


  const [formValues, setFormValues] = useState(initialValues);
  const parameters = useSelector((state) => state.parameters);
  const customerCodeInputRef = useRef(true);
  const formRef = useRef();

  const dispatch = useDispatch();
  const platform = appHelpers.getPlatform();


  const { selectedCustomer, currencyList } = useSelector((state) => state.sheetPaymentFilters);
  const { code1List, code2List, code3List, code4List, code5List, divisionList, departmentList, netsisGroupCodes } = useSelector((state) => state.erpValues);


  useLayoutEffect(() => {
    // dispatch(clearState());
  }, [])
  useEffect(() => {

  }, [formValues]);

  useEffect(() => {

    if (selectedCustomer.code) {
      customerCodeInputRef.current.setValue(selectedCustomer.code);
      dispatch(clearSheetPaymentCustomer());
    }


  }, [selectedCustomer]);

  const onSubmit = async (values, actions) => {
    var netisGroupCodes = "";
    if (values.netsisGroupCode && values.netsisGroupCode.length > 0) {
      netisGroupCodes = values.netsisGroupCode.map(val => val.value).join(', ')
    }
    var tempStart = (values.amountRange.start || "").replaceAll(".", "").replaceAll(",", "");
    var tempEnd = (values.amountRange.end || "").replaceAll(".", "").replaceAll(",", "");
    if (parseInt(tempEnd) > 0) {
      if (parseInt(tempStart) > parseInt(tempEnd)) {
        toast.error("Başlangıç tutarı Bitiş tutarından büyük olamaz.");
        return;
      }
    }

    var filterParams = {
      customerCode: values.customerCode,
      code1: values.code1.map(val => val.value).join(', '),
      code2: values.code2.map(val => val.value).join(', '),
      code3: values.code3.map(val => val.value).join(', '),
      code4: values.code4.map(val => val.value).join(', '),
      code5: values.code5.map(val => val.value).join(', '),
      netsisGroupCode: netisGroupCodes,
      department: values.department.map(val => val.value).join(', '),
      division: values.division.map(val => val.value).join(', '),
      currencyType: values.currencyType,
      balanceStart: values.amountRange.start,
      balanceEnd: values.amountRange.end,
      companyNr: appHelpers.getNetsisBranchCode(),
      firmNumber: appHelpers.getFirmNumber(),
      selectedAmountType: values.selectedAmountType || 1
    };


    var callbackParameters = {
      SelectedAmountType: values.selectedAmountType || 1,
      BalanceStart: values.amountRange.start,
      BalanceEnd: values.amountRange.end,
    }
    var messageBody = {
      requestType: postMessageTypes.selectCustomerListByFilter,
      requestBody: JSON.stringify(filterParams),
      callbackParameters: JSON.stringify(callbackParameters)
    };
    postWebViewMessage(JSON.stringify(messageBody));

    setFiltersIsOpen(false);

  };

  useEffect(() => {
    selectCurrencyList();
    selectGroupCodes();
    selectDivision();
    selectDepartment();

  }, []);
  const selectCurrencyList = () => {
    if (platform == "NETSIS") {
      var messageBody = { requestType: postMessageTypes.selectCurrencyList, requestBody: "", callbackParameters: "" };
      postWebViewMessage(JSON.stringify(messageBody));
    } else {
      dispatch(onSelectCurrencyTypes(currencyTypes));
    }
  }




  const openCustomerForm = () => {

    var callbackParameters = {
      customerSelectFrom: customerSelectFrom.fromSheetPayment
    }

    var messageBody = { requestType: postMessageTypes.getCustomerInfo, requestBody: "", callbackParameters: JSON.stringify(callbackParameters) };
    postWebViewMessage(JSON.stringify(messageBody));
  }

  function submitForm() {
    formRef.current.submitForm();
  }
  const onUpdate = (value) => {
    setFormValues(Object.assign(formValues, value));
    submitForm();

  };
  const clearFilters = (resetForm) => {

    formRef.current.resetForm()

    dispatch(updateIsResetForm(true));
    setTimeout(() => {
      dispatch(updateIsResetForm(false));
    }, 1000);

    submitForm();
  };


  const getCode3View = (isMargin) => (
    <div className={isMargin ? "mt-2" : ""}>
      <FormMultiSelect options={code3List}
        name="code3"
        placeholder="Tümü"
        label="Özel Kod 3"
        value={formValues.code3}
        isMulti
        defaultValue={formValues.code3}
      >
      </FormMultiSelect>
    </div>
  )
  const getCode4View = () => (
    <div className="mt-2">
      <FormMultiSelect options={code4List}
        name="code4"
        placeholder="Tümü"
        label="Özel Kod 4"
        value={formValues.code4}
        isMulti
        defaultValue={formValues.code4}
      >

      </FormMultiSelect>
    </div>
  )
  const getCode5View = () => (
    <div className="mt-2">
      <FormMultiSelect options={code5List}
        name="code5"
        placeholder="Tümü"
        label="Özel Kod 5"
        value={formValues.code5}
        isMulti
        defaultValue={formValues.code5}
      >

      </FormMultiSelect>
    </div>
  )

  const shortFilterFields = [
    { key: "customerCode", label: "Müşteri Kodu", type: "text" },
    { key: "amountRange", label: "Bakiye Aralığı", type: "object", datatype: "moneyrange" },
    {
      key: "currencyType",
      label: "Döviz Türü",
      type: "select",
      options: currencyList,
    },
    {
      key: "selectedAmountType",
      label: "Cari Bakiye Sorgulama Türü",
      type: "select",
      options: amountTypes,
    },
    { key: "department", label: "Bölüm", type: "text" },
    { key: "divisioun", label: "İşyeri", type: "text" },
    { key: "code1", label: "Özel Kod 1", type: "text" },
    { key: "code2", label: "Özel Kod 2", type: "text" },
    { key: "code3", label: "Özel Kod 3", type: "text" },
    { key: "code4", label: "Özel Kod 4", type: "text" },
    { key: "code5", label: "Özel Kod 5", type: "text" },
  ];

  const getAmountTypeView = () => amountTypeVisible() ? (
    <div className="mt-2">
      <FormSelector
        options={amountTypes}
        name="selectedAmountType"
        placeholder={amountTypes[0].label}
        label="Cari Bakiye Sorgulama Türü"
        value={amountTypes.find(s => s.value == formValues.selectedAmountType)}
      />
    </div>
  ) : null

  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      // validationSchema={filtersSchema}
      onSubmit={onSubmit}
    >
      <Form>
        <FormObserver
          watch={(val) => {
            setFormValues(val);
          }}
        />
        <div className={`mx-4 my-2 px-4 py-2 bg-white shadow-md ${!isOpen ? "hidden" : ""}`} >
          <div className="grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-3 xl:grid-cols-3 mt-2">
            <div className=" ">
              <h1 className="text-left px-2 font-semibold">Genel Alanlar</h1>
              <div className="flex flex-col justify-start px-0 mt-2 ">


                <div className="">
                  <FormInput
                    label="Cari Hesap Kodu"
                    name="customerCode"
                    type="text"
                    defaultValue={selectedCustomer.code}
                    ref={customerCodeInputRef}
                    rightIcon={isLogoAppProject() &&
                      <TbDots
                        onClick={openCustomerForm}
                        className="sm:block h-6 w-6 text-black hidden cursor-pointer color-primary-color "
                        aria-hidden="true"
                        color="#0090FF"
                      />
                    }
                  />
                </div>



                <div className="mt-2">
                  <AmountRange label="Bakiye Aralığı" name="amountRange" />
                </div>

                {getAmountTypeView()}

                <div className="mt-2">
                  <FormSelector
                    options={currencyList}
                    name="currencyType"
                    placeholder="Tümü"
                    label="Döviz Türü"
                    isDisabled={formValues.selectedAmountType != 1}
                    value={currencyList.find(s => s.value == formValues.currencyType)}
                  />
                </div>
              </div>
            </div>
            <div className=" col-span-2">
              <h1 className="text-left font-semibold px-2">Cari Hesap</h1>
              <div className="grid lg:grid-cols-2 gap-2 sm:gap-6 mt-2 ">
                <div className="flex flex-col justify-start px-0">

                  {platform == "NETSIS" ? (
                    <div className="">
                      <FormMultiSelect
                        options={netsisGroupCodes || []}
                        name="netsisGroupCode"
                        placeholder="Tümü"
                        label="Grup Kodu"
                        value={formValues.netsisGroupCode}
                        isMulti
                        defaultValue={formValues.netsisGroupCode}
                      >

                      </FormMultiSelect>
                    </div>
                  ) : null}
                  <div className={platform == "NETSIS" ? "mt-2" : ""}>
                    <FormMultiSelect options={code1List}
                      name="code1"
                      placeholder="Tümü"
                      label="Özel Kod 1"
                      value={formValues.code1}
                      isMulti
                      defaultValue={formValues.code1}
                    >

                    </FormMultiSelect>
                  </div>
                  <div className="mt-2">
                    <FormMultiSelect options={code2List}
                      name="code2"
                      placeholder="Tümü"
                      label="Özel Kod 2"
                      value={formValues.code2}
                      isMulti
                      defaultValue={formValues.code2}
                    >

                    </FormMultiSelect>
                  </div>
                  {platform == "NETSIS" ? null : (
                    <>
                      {getCode3View(true)}

                      {getCode4View()}
                      {getCode5View()}
                    </>
                  )}




                </div>


                <div className="flex flex-col justify-start px-0">
                  {platform !== "NETSIS" ? (
                    <>
                      <div>
                        <FormMultiSelect options={departmentList}
                          name="department"
                          placeholder="Tümü"
                          label="Bölüm"
                          value={formValues.department}
                          isMulti
                          defaultValue={formValues.department}
                        >

                        </FormMultiSelect>
                      </div>
                      <div className="mt-2">

                        <FormMultiSelect options={divisionList}
                          name="division"
                          placeholder="Tümü"
                          label="İşyeri"
                          value={formValues.division}
                          isMulti
                          defaultValue={formValues.division}
                        >

                        </FormMultiSelect>
                      </div>
                    </>
                  ) : (
                    <>
                      {getCode3View(false)}

                      {getCode4View()}
                      {getCode5View()}

                    </>

                  )}


                </div>


              </div>


            </div>

          </div>
          <div className="flex justify-end mt-2 mr-0">
            <Button
              type="reset"
              color="gray"
              hover="gray"
              size="sm"
              className="mr-3"
              callback={() => {
                clearFilters()
              }}
            >
              <img src="/icons/delete-blue.svg" alt="deleteFilter" />
              <span className='ml-3'>{buttonTexts.filterClear}</span>
            </Button>

            <Button type="submit" color="primary" hover="primary" size="sm">
              <img src="/icons/prepare-white.svg" alt="prepare" />
              <span className='ml-3 mr-3'>{buttonTexts.filterSubmit}</span>
            </Button>
          </div>
        </div>

        <div
          className={`m-4 px-4 py-3 bg-white shadow-md ${isOpen ? "hidden" : ""
            }`}
        >
          <FormFiltersShortList
            formValues={{ ...formValues }}
            fields={shortFilterFields}
            initialValues={initialValues}
            callback={(val) => onUpdate(val)}
            clearFilter={() => {
              clearFilters()
              submitForm()
            }}
          />
        </div>
      </Form>
    </Formik>
  );
}

String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.split(search).join(replacement);
};